import { httpService } from "utils";

import { IEReservationContext } from "../types/IEReservationContext";

export const getContext = (
  friendlyUrl: string = "default"
): Promise<IEReservationContext> => {
  return httpService().get<IEReservationContext>(
    `/contexts/${friendlyUrl}/e-reservation`
  );
};

export const getContextKey = () => "context";
